<template>
  <v-col
    cols="12"
    sm="4"
  >
    <validation-provider
      v-slot="{ errors }"
      :rules="rules"
      name="select"
    >
      <v-select
        v-model="value"
        :items="items"
        :error-messages="errors"
        :no-data-text="$t('error.provider')"
        item-text="name"
        item-value="type"
        @input="$emit('input', $event)"
      >
        <template v-slot:label>
          {{ label }}
          <span
            v-if="required"
            class="red--text"
          >
            *
          </span>
        </template>
      </v-select>
    </validation-provider>
  </v-col>  
</template>

<script>
  import { ValidationProvider } from 'vee-validate';

  export default {
    name: "DeliverySelectField",
    components: {
      ValidationProvider,
    },
    data: () => ({
      value: "",
    }),
    props: {
      rules: {
        type: String,
        default: "",
      },
      items: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
    }
  }
</script>
